/** 문항 카드 AI 액션 상수. 카피는 hooks/useQuestionCardAiCopy, 메뉴 표시는 questionCardAiMenu.const 에 있다. */
import { type BuildQuizListItem } from '../../../form/schema/BuildQuizListSchema';

/** 단발 JSON 요청 타임아웃. 클라이언트 AbortController 와 fetch 기본 signal 이 같은 값을 쓴다. */
export const QUESTION_CARD_AI_TIMEOUT_MS = 60_000;

/** 결과가 너무 빨리 오면 스켈레톤이 깜빡이기만 한다 (PRD §7-6). 유사 문제에만 적용. */
export const MIN_SKELETON_MS = 400;

/** P1 — 난이도 상향은 품질 확보 후 켠다 (PRD §2). */
export const HARDER_ENABLED = false;

/**
 * AI 액션이 다루는 문항 유형 — 서버 wire 의 quiz_type 과 같은 집합이다. 유사 문제는 전부,
 * 선지 채움은 이 중 슬롯 스키마(QUIZ_SLOT_SCHEMA)가 있는 유형만 다룬다. 여기 없는 유형은
 * 메뉴 항목이 비어 데스크톱 트리거와 모바일 drawer 항목이 모두 사라진다.
 */
export const QUESTION_CARD_AI_QUIZ_TYPES = [
  'ox',
  'multiple',
  'subjective',
  'essay',
] as const satisfies readonly BuildQuizListItem['type'][];

/** 서버 도메인 거절 코드. FE 는 status 가 아니라 code 로 카피를 고른다. */
export const QUESTION_CARD_AI_ERROR_CODES = [
  'UNSUPPORTED_QUIZ_TYPE',
  'INVALID_QUESTION',
  'NO_EMPTY_SLOTS',
  'GENERATION_FAILED',
  'GENERATION_TIMEOUT',
] as const;

export type QuestionCardAiErrorCode =
  (typeof QUESTION_CARD_AI_ERROR_CODES)[number];

/** 트리거 우상단 플랜 뱃지의 플랜 — 문항 카드 AI 액션 3종은 BASIC 부터 열린다. */
export const QUESTION_CARD_AI_PLAN_TYPE = 'BASIC' as const;
